/**
 * This functions sets up an intersection observer that assigns the CSS class 'is-sticky-pinned'
 * to the given sticky element once its position starts to be pinned by the sticky CSS property
 * (i.e. the parent element starts to be scrolled down), and removes it when the element is using
 * its "normal" non-sticky position again (i.e. when the containing element is scrolled up again).
 *
 * @param stickyElement - The element that is positioned using 'sticky'
 * @param rootElement - The containing scrolling element, defaults to the browser viewport if not specified.
 * @return A function that the caller can call to stop observing the element when done
 */
export function observeStickyElementStickiness(stickyElement: HTMLElement, rootElement?: HTMLElement): () => void {
  const isTop = getComputedStyle(stickyElement).top !== 'auto'; // Otherwise, it is sticky to the bottom
  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyElement.classList.toggle('is-sticky-pinned', !entry.isIntersecting);
    },
    { root: rootElement ?? null, rootMargin: isTop ? '-1px 0px 0px 0px' : '0px 0px -1px 0px', threshold: 1 },
  );
  observer.observe(stickyElement);
  return () => observer.disconnect();
}
